import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TeamMemberEventState, TeamMemberEvent, EventFilters } from './types'
import { fetchTeamMemberEvent } from './action'

const initialState: TeamMemberEventState = {
  data: null,
  loading: false,
  error: null,
  filters: {
    registered: {
      status: ['active'],
      isArchived: false,
    },
    unregistered: {
      status: ['active'],
      isArchived: false,
      isCompleted: false,
    },
  },
}

const teamMemberEventsSlice = createSlice({
  name: 'teamMemberEvents',
  initialState,
  reducers: {
    setRegisteredFilters: (state, action: PayloadAction<EventFilters>) => {
      state.filters.registered = action.payload
    },
    setUnregisteredFilters: (state, action: PayloadAction<EventFilters>) => {
      state.filters.unregistered = action.payload
    },
    resetFilters: (state) => {
      state.filters = initialState.filters
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeamMemberEvent.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchTeamMemberEvent.fulfilled, (state, action: PayloadAction<TeamMemberEvent>) => {
        state.loading = false
        state.data = action.payload
      })
      .addCase(fetchTeamMemberEvent.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

export const { setRegisteredFilters, setUnregisteredFilters, resetFilters } =
  teamMemberEventsSlice.actions
export default teamMemberEventsSlice.reducer
